import { BookOpen01, Film01, Headphones01, Image01 } from "@untitledui/icons"
import type { FC } from "react"

import { Label } from "@/components/ui/input"
import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"
import { ContentBodyTypeEnum } from "@/types"

interface ContentTypeOption {
  value: ContentBodyTypeEnum
  label: string
  Icon: FC<{ className?: string }>
}

const options: ContentTypeOption[] = [
  { value: ContentBodyTypeEnum.video, label: "Video", Icon: Film01 },
  { value: ContentBodyTypeEnum.audio, label: "Audio", Icon: Headphones01 },
  { value: ContentBodyTypeEnum.article, label: "Article", Icon: BookOpen01 },
  { value: ContentBodyTypeEnum.photo, label: "Photo", Icon: Image01 },
]

interface ContentTypeSelectorProps {
  value: ContentBodyTypeEnum
  onChange: (next: ContentBodyTypeEnum) => void
}

/**
 * ContentTypeSelector component
 * It contains a row of icon squares selection for switching the track's content body type form.
 */
export default function ContentTypeSelector({
  value,
  onChange,
}: ContentTypeSelectorProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="hidden">Content Type</Label>
      <div className="flex gap-2.5">
        {options.map(({ value: optionValue, label, Icon }) => {
          const isSelected = value === optionValue
          return (
            <Tooltip key={optionValue} title={label} placement="top">
              <TooltipTrigger
                aria-label={label}
                aria-pressed={isSelected}
                onPress={() => onChange(optionValue)}
                className={cn(
                  "flex h-15 flex-1 cursor-pointer items-center justify-center rounded-xl border border-2 transition duration-100 ease-linear lg:h-17",
                  isSelected
                    ? "border-brand bg-brand-50 text-brand-600"
                    : "border-secondary bg-primary text-quaternary hover:border-brand hover:bg-secondary",
                )}
              >
                <Icon className="size-6 md:size-7" />
              </TooltipTrigger>
            </Tooltip>
          )
        })}
      </div>
    </div>
  )
}
